import React, { useContext } from "react";
import style from "./index.module.scss";
import { Spin } from "antd";
import { CourseContext } from "../Store";
import CustomEmpty from "../../../components/CustomEmpty";
import ListItem from "./components/ListItem";
import { getCloudDeskTopList } from "../../../API/experiment";
import useRequest from "../../../Utils/useRequest";

export default function Experiment() {
    const { course } = useContext(CourseContext);

    const [data, { loading }, refreshData] = useRequest(() =>
        getCloudDeskTopList(course.weekTimeId)
    );

    return (
        <div className={style.root}>
            <div className={style.header}>
                <div className={style.count}>
                    实验任务（{data?.length || 0}）
                </div>
            </div>

            <Spin spinning={loading}>
                {data?.map((item, index) => (
                    <ListItem data={item} key={index} onChange={refreshData} />
                ))}
                {!data?.length && (
                    <CustomEmpty style={{ padding: "100px 0" }} />
                )}
            </Spin>
        </div>
    );
}
